export const downloadFile = (data, name) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([data]));
  link.download = name;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};

export const extractFileNameFromHeaders = (headers) => {
  return headers['content-disposition'].split('"')[1];
};
